import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  form: {
    width: '100%',
  },
  note: {
    fontSize: '.7rem',
    color: 'rgba(0, 0, 0, 0.38)',
  },
}));

export default useStyles;
